document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.filter-btn');
    const childFilterButtons = document.querySelectorAll('.child-filter-btn');
    const searchInput = document.getElementById('search-input');
    const searchBtn = document.getElementById('search-btn');
    const clearBtn = document.getElementById('clear-btn');

    // Get current URL parameters
    function getCurrentParams() {
        const urlParams = new URLSearchParams(window.location.search);
        return {
            filter: urlParams.get('filter') || '',
            child_filter: urlParams.get('child_filter') || '',
            query: urlParams.get('query') || ''
        };
    }

    // Build URL with parameters
    function buildURL(params) {
        const url = new URLSearchParams();
        
        if (params.filter && params.filter !== 'all') {
            url.set('filter', params.filter);
        }
        if (params.child_filter && params.child_filter !== 'all') {
            url.set('child_filter', params.child_filter);
        }
        if (params.query && params.query.trim() !== '') {
            url.set('query', params.query.trim());
        }

        const queryString = url.toString();
        return window.location.pathname + (queryString ? '?' + queryString : '');
    }

    // Search functionality
    function performSearch() {
        const currentParams = getCurrentParams();
        const searchText = searchInput.value.trim();
        
        currentParams.query = searchText;
        window.location.href = buildURL(currentParams);
    }

    // Clear functionality
    function clearSearch() {
        window.location.href = window.location.pathname;
    }

    // Set search input value from URL on page load
    const currentParams = getCurrentParams();
    if (currentParams.query) {
        searchInput.value = currentParams.query;
    }

    // Restore focus from sessionStorage
    const lastFocusedId = sessionStorage.getItem('lastFocusedElement');
    if (lastFocusedId) {
        const el = document.getElementById(lastFocusedId);
        if (el) el.focus();
        sessionStorage.removeItem('lastFocusedElement');
    }

    // Utility to set last focused element before navigation
    function setLastFocusedElement(el) {
        if (el && el.id) {
            sessionStorage.setItem('lastFocusedElement', el.id);
        }
    }

    // Search button click
    if (searchBtn) {
        searchBtn.addEventListener('click', function() {
            setLastFocusedElement(searchBtn);
            performSearch();
        });
    }

    // Enter key in search input
    if (searchInput) {
        searchInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                setLastFocusedElement(searchInput);
                performSearch();
            }
        });
    }

    // Clear button click
    if (clearBtn) {
        clearBtn.addEventListener('click', function() {
            setLastFocusedElement(clearBtn);
            clearSearch();
        });
    }
   
    // Parent filter buttons
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            setLastFocusedElement(button);
            const filter = this.getAttribute('data-filter');
            const currentParams = getCurrentParams();
            
            if (filter === 'all') {
                // Remove filter and child_filter, keep search query
                currentParams.filter = '';
                currentParams.child_filter = '';
            } else {
                // Set new filter, remove child_filter, keep search query
                currentParams.filter = filter;
                currentParams.child_filter = '';
            }
            
            window.location.href = buildURL(currentParams);
        });
    });
 
    // Child filter buttons
    childFilterButtons.forEach(button => {
        button.addEventListener('click', function() {
            setLastFocusedElement(button);
            const filter = this.getAttribute('data-filter');
            const parent = this.getAttribute('data-parent');
            const currentParams = getCurrentParams();

            if (filter === 'all') {
                // Show all posts from parent category, keep search query
                currentParams.filter = parent;
                currentParams.child_filter = '';
            } else {
                // Filter by child taxonomy, keep search query
                currentParams.filter = parent;
                currentParams.child_filter = filter;
            }
            
            window.location.href = buildURL(currentParams);
        });
    });
});